const BannerWithCTA = () => {
    
    if ($('.section-banner-with-cta').length <= 0) return null;

    $('.section-banner-with-cta').each(function() {
        const $parent = $(this);
        const $tooltipToggle = $parent.find('.tooltip-toggle');
    
        const $tooltipPopupDesk = $parent.find('.inner-wrapper .tooltip-content');
        const $tooltipPopupMob = $parent.find('.mobile-tooltip-popups .tooltip-content');
        
        const $tooltipCloseDesk = $parent.find('.close-tooltip-popup.desk');
        let $tooltipCloseMob = null;
        if ($parent.find('.close-tooltip-popup.mob').length > 0) {
            $tooltipCloseMob = $parent.find('.close-tooltip-popup.mob');
        } else if ($parent.next('.collections-separate-mobile-popup').length > 0) {
            $tooltipCloseMob = $parent.next('.collections-separate-mobile-popup').find('.close-tooltip-popup.mob')
        }
        
        $tooltipToggle.click(function() {
            //desktop
            if ($(window).width() >= 1200) {
                $(this).closest('.tooltip-group').toggleClass('active')
                $tooltipPopupDesk.stop().fadeToggle(300); 
            } else {
                if ($parent.hasClass('collection-bwc') == false)
                $parent.find('.mobile-tooltip-popups').fadeIn(300);
            }
        })
    
        //mobile tooltip click on collections
        if ($parent.hasClass('collection-bwc')) {
            let colId = $parent.attr('id');
            $tooltipToggle.click(function() {
                if ($(window).width() < 1200) {
                    $(`#${colId}-mob-popup`).fadeIn(300);
                }
            })
        }
    
        //close desktop
        $tooltipCloseDesk.click(function() {
            $(this).closest('.tooltip-content').stop().fadeOut(300);
            $(this).closest('.tooltip-group').removeClass('active');
        })
    
        //close mobile
        $tooltipCloseMob.click(function() {
            $(this).closest('.mobile-tooltip-popups').fadeOut(300);
        })
    })
}

export default BannerWithCTA